import { render, staticRenderFns } from "./SalesBudgets.vue?vue&type=template&id=fc0d2670&scoped=true"
import script from "./SalesBudgets.vue?vue&type=script&lang=js"
export * from "./SalesBudgets.vue?vue&type=script&lang=js"
import style0 from "./SalesBudgets.vue?vue&type=style&index=0&id=fc0d2670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0d2670",
  null
  
)

export default component.exports